import React from 'react';
import { useTranslation } from 'react-i18next';

const ClinicalValue = () => {
  const { t } = useTranslation();

  return (
    <section id="problem" className="bf-section">
      <div className="bf-container">
        <div className="bf-section-head">
          <span className="bf-eyebrow"><span className="dot"></span>{t('problem.eyebrow', 'The problem today')}</span>
          <div>
            <h2>
              {t('problem.titleA', 'Half a doctor’s time in the EMR')}
              <br />
              <span className="bf-grad-text">{t('problem.titleB', 'isn’t spent on the patient.')}</span>
            </h2>
            <p className="bf-lead" style={{ marginTop: 20, maxWidth: '58ch', color: 'var(--bf-muted)' }}>
              {t(
                'problem.lead',
                'Too much of a clinician’s day goes to piecing the record together — not to the patient in front of them.'
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClinicalValue;
